import { defineMessages } from 'react-intl';

export default defineMessages({
  successMessage: 'Stan konta',
  warningMessage: 'Niski stan konta',
  errorMessage: 'Brak środków',
  notCollapsedMenuPoints: '{points} pkt',
  collapsedMenuPoints: '{points}',
});
